// Auto generated file, do not manually modify!
// com.hotpads.renterinfo.client.renterprofile.enums.RenterProfileHasPets

export enum RenterProfileHasPets {
  NO = 'NO',
  UNKNOWN = 'UNKNOWN',
  YES = 'YES',
}

export const RenterProfileHasPets_values = [
  RenterProfileHasPets.NO,
  RenterProfileHasPets.UNKNOWN,
  RenterProfileHasPets.YES,
] as const;
